// extracted by mini-css-extract-plugin
export default {"info":"_7ca8149e","photo":"_2ee87d1c","title":"_dfb41770","description":"_c3677996","expandableWrapper":"_35f77d4f","content":"_5f1dfc79"};